import { render, staticRenderFns } from "./ArticleContentForm.vue?vue&type=template&id=8866798c&"
import script from "./ArticleContentForm.vue?vue&type=script&lang=js&"
export * from "./ArticleContentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports